// https://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport/7557433#7557433function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
        rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
    );
}

//function onVisibilityChange(el, callback) {
//    var old_visible;
//    return function () {
//        var visible = isElementInViewport(el);
//        if (visible !== old_visible) {
//            old_visible = visible;
//            if (typeof callback === 'function') {
//                callback();
//            }
//        }
//    };
//}

function onVisibilityChange(el, callback) {
    // var old_visible;
    return function () {
        // var visible = isElementInViewport(el);
        if (isElementInViewport(el)) {
            // old_visible = visible;
            if (typeof callback === 'function') {
                callback();
            }
        }
    };
}


//var handler = onVisibilityChange(elementVarName, function () {

//});

//if (window.addEventListener) {
//    addEventListener('DOMContentLoaded', handler, false);
//    addEventListener('load', handler, false);
//    addEventListener('scroll', handler, false);
//    addEventListener('resize', handler, false);
//}